export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";